{
  "more": "Mais artigos"
}
